export const theme = {
  colors: {
    black: '#000;',
    yellow: '#E42522',
    yellowHover: '#f43330',
    white: '#fff',
    grey: '#c1c1c1',
  },
}
